import FavoriteMenuBar from "./favorite-menu-bar";

export default FavoriteMenuBar;